import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import type { GridFieldType } from '@/features/Inventory/ObjectTypePassportGrid/model/types'

/**
 * After loading `passport_grid_template` from the API, fix cells that belong to this catalog’s
 * own fields but were saved with wrong `palette_source` / `inventory_type` (e.g. parent type id
 * from {@link normalizeForSave} fallback order). Client-only correction — does not mark dirty by itself
 * unless the template reference is reassigned.
 *
 * Cells whose `id` is palette-sourced are left unchanged — patterns in `docs/passport-builder-v2-palette-ids.md` §5 (repo root).
 */
export function normalizeGridTemplateChrome(
  template: GridFieldType[],
  catalogFields: ObjectInventoryField[],
  catalogTypeId: number,
): GridFieldType[] {
  if (!catalogTypeId || catalogTypeId <= 0 || !template.length) return template

  const byId = new Map<string, ObjectInventoryField>()
  for (const f of catalogFields) {
    byId.set(String(f.id), f)
  }

  return template.map((item) => {
    if (item.type === 'heading' || item.type === 'table') return item
    const sid = String(item.id)
    if (
      sid.startsWith('ref:') ||
      sid.startsWith('list:') ||
      sid.startsWith('parent-obj-name:') ||
      sid.startsWith('list-catalog-name:') ||
      sid.includes('#f:') ||
      sid.includes('#b:') ||
      sid.includes('parent-acc-') ||
      sid.startsWith('list-') ||
      sid.includes('::')
    ) {
      return item
    }

    const inv = byId.get(sid)
    if (!inv) return item
    if (Number(inv.object_type) !== catalogTypeId) return item

    return {
      ...item,
      palette_source: 'own',
      inventory_type: catalogTypeId,
    }
  })
}
